import React from 'react'

const Header = () => {
    return(
        <div className="header">
            <p className="header__title">Aplikacja e-recepta</p>
        </div>
    )
}

export default Header;